import React from 'react';
import MuiSidebar from './MuiSidebar';

/**
 * SidebarWithAccordion - 使用 Accordion 的侧边栏组件
 * 支持可折叠的菜单项，类似 Material Tailwind 的样式
 */
function SidebarWithAccordion({
  courseName,
  courseTermCode,
  navigationItems = [],
  navigationGroups = [],
  userInfo,
  onLogout,
  footerContent,
  children,
  collapsed = false,
  onToggleCollapse,
  onSettingsClick
}) {

  // 使用 react-mui-sidebar 库
  return (
    <MuiSidebar
      courseName={courseName}
      courseTermCode={courseTermCode}
      navigationItems={navigationItems}
      navigationGroups={navigationGroups}
      userInfo={userInfo}
      onLogout={onLogout}
      footerContent={footerContent}
      children={children}
      collapsed={collapsed}
      onToggleCollapse={onToggleCollapse}
      onSettingsClick={onSettingsClick}
    />
  );
}

export default SidebarWithAccordion;
